import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BONUS_TOTAL, bonuses } from '../data/religia';
export function Bonuses() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-35" data-mp="pjg5q15wl80x">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-36" data-mp="avuzvzhn8upb">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-4" data-id="element-37" data-mp="ftwlar2jl63y">
          <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-38" data-mp="fs3d37ca6dtu">Ale to nie wszystko!</p>
          <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-39" data-mp="1whsdcd2yg78">
            5 bonusów <em className="text-red-700" data-id="element-40" data-mp="3o1v4md2kroo3">bez dodatkowych kosztów</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-900/75" data-id="element-41" data-mp="3o3y6bud3b68n">
            Pięć dodatkowych materiałów o łącznej wartości {BONUS_TOTAL} otrzymujesz razem z sześcioma
            tomami – aby jeszcze łatwiej prowadzić lekcje religii przez cały rok.
          </p>
        </div>

        <ol className="border-t border-slate-900/15 lg:col-span-8" data-id="element-42" data-mp="1r78s9atlm4uc">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid grid-cols-[2.5rem_1fr] gap-x-5 border-b border-slate-900/15 py-9 sm:grid-cols-[3.5rem_1fr] sm:gap-x-8" data-id="element-43" data-mp="3icbt3rz3hpmb" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700 sm:text-6xl" aria-hidden="true" data-id="element-44" data-mp="3r5ovrlmyo5ll">
                {index + 1}
              </span>
              <div data-id="element-45" data-mp="2zfkh83lvucsa">
                <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3" data-id="element-46" data-mp="2zf2csjp2gs9a">
                  <h3 className="max-w-md font-serif text-2xl leading-tight text-slate-900 sm:text-3xl" data-id="element-47" data-mp="2uh0q7osfmat2">
                    <span className="sr-only" data-id="element-48" data-mp="38gim0o45aobx">Bonus {index + 1} – </span>
                    {bonus.title}
                  </h3>
                  <span className="shrink-0 -rotate-3 rounded border-2 border-red-700 px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-red-700" data-id="element-49" data-mp="33fm6teecffr7">
                    W zestawie
                  </span>
                </div>
                <p className="mt-2 text-sm font-semibold text-slate-900/70" data-id="element-50" data-mp="itaty8ie615f">
                  Wartość: <s className="text-slate-900/50" data-id="element-51" data-mp="3cl0rkxnpg0eo">{bonus.value}</s> · w pakiecie bez dopłaty
                </p>
                <p className="mt-3 max-w-xl leading-relaxed text-slate-900/75" data-id="element-52" data-mp="3hju9d2a0ydkn">{bonus.text}</p>
                <ul className="mt-4 grid max-w-xl gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-53" data-mp="3lhry63zvuxni">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-slate-900/75" data-id="element-54" data-mp="2tsf2qxb7ta3l">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-55" data-mp="2xu0ay5ct107g" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 max-w-xl font-serif text-lg italic leading-snug text-red-700" data-id="element-56" data-mp="37jtkz1xat79l">
                  {bonus.benefit}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}